export const ANTI_MONEY_LAUNDERING = "Anti Money Laundering";
export const BANK_ACCOUNT_COMPANY_VERIFICATION = "Bank Account Company Verification";
export const BANK_ACCOUNT_INDIVIDUAL_VERIFICATION = "Bank Account Individual Verification";
export const ENTERPRISE_ANTI_MONEY_LAUNDERING = "Enterprise Anti Money Laundering";
export const ENTERPRISE_KYB = "Enterprise KYB";
export const ENTERPRISE_CREDIT_CHECK = "Enterprise Credit Check";
export const CIPC_VERIFICATION = "CIPC Verification"
export const SEARCH_FCRA = "Search FCRA";
export const FACIAL_BIOMETRICS_VERIFY = "ID Verification (Facial Biometrics)"
export const FACIAL_BIOMETRICS_VERIFY_LIVENESS = "ID Verification (Liveness check)"
export const OCR_VERIFICATION = "OCR verification"

export const ENTERPRISE_TRANSUNION_KYB_ENQUIRY_REASON = "Credit Limit Management";
export const ENQUIRY_REASONS = [
    { key: 'AccessCheck', value: 'Access Check' },
    { key: 'Affordability', value: 'Affordability/Financial Means assessment' },
    { key: 'AffordabilityAssessment', value: 'Affordability / Financial means assessment' },
    { key: 'Contactibility', value: 'Contactibility (Fraud)' },
    { key: 'CreditInformationQuery', value: 'Credit Information Query and/or Dispute' },
    { key: 'CreditLimitManagement', value: 'Credit Limit Management' },
    { key: 'CreditRisk', value: 'Credit Risk' },
    { key: 'CreditScoringModel', value: 'Credit Scoring Model' },
    { key: 'DebtCounseling', value: 'Debt Counseling' },
    { key: 'DebtorBookAssessment', value: "Debtor's Book Assessment" },
    { key: 'Employment', value: 'Employment (handling finances)' },
    { key: 'FraudCorruptionTheftInv', value: 'Fraud, Corruption, or Theft Investigation' },
    { key: 'FraudDetectionFraudPrev', value: 'Fraud Detection and Fraud Prevention' },
    { key: 'InsuranceApplication', value: 'Insurance Application' },
    { key: 'InternalEnquiry', value: 'Internal Enquiry' },
    { key: 'InternationalEnquiry', value: 'International Enquiry' },
    { key: 'ModelDevelopment', value: 'Model Development as per law' },
    { key: 'Other', value: 'Other - as per law' },
    { key: 'PrescreeningMarketing', value: 'Prescreening/Marketing' },
    { key: 'SettingLimit', value: 'Setting limit for goods/utility/service' },
    { key: 'Tracing', value: 'Tracing by credit provider' },
    { key: 'TracingByCreditProvider', value: 'TracingByCreditProvider/agent' },
    { key: 'UnclaimedFundsDistribution', value: 'Unclaimed funds distribution' },
];

// Enterprise KYB product codes
export const KYB_VERIFICATION_CODE = "5110,5112"// Statutory Detail on File = 5110, Principal Detail = 5112
export const KYB_CREDIT_CHECK_CODE = "5099,5110,5112" // CV4B SACRRA Online

export const BANK_CODE_UNIVERSAL = [
    { key: "Not Selected", code: "", branch: "" },
    { key: "ABN AMRO BANK", code: "", branch: "Universal" },
    { key: "ABSA BANK", code: "632005", branch: "Universal" },
    { key: "AFRICAN BANK", code: "430000", branch: "Universal" },
    { key: "BANK WINDHOEK", code: "482072", branch: "Universal" },
    { key: "BIDVEST BANK", code: "462005", branch: "Universal" },
    { key: "BOE BANK (NEDBANK)", code: "198765", branch: "Universal" },
    { key: "CAPITEC BANK", code: "470010", branch: "Universal" },
    { key: "CITIBANK", code: "350005", branch: "Universal" },
    { key: "FBC FIDELITY BANK LTD", code: "", branch: "Universal" },
    { key: "FIRST NATIONAL BANK", code: "250655", branch: "Universal" },
    { key: "GRINDROD BANK", code: "584000", branch: "Universal" },
    { key: "HABIB OVERSEAS BANK", code: "", branch: "Universal" },
    { key: "HBZ BANK", code: "", branch: "Universal" },
    { key: "INVESTEC BANK LIMITED", code: "580105", branch: "Universal" },
    { key: "MERCANTILE BANK", code: "450105", branch: "Universal" },
    { key: "MFC", code: "", branch: "Universal" },
    { key: "MTN BANKING (Standard Bank)", code: "490991", branch: "Universal" },
    { key: "NBS (Nedbank)", code: "198765", branch: "Universal" },
    { key: "NEDBANK", code: "198765", branch: "Universal" },
    { key: "NEDBANK (Lesotho)", code: "390061", branch: "Universal" },
    { key: "NEDBANK (Namibia)", code: "461001", branch: "Universal" },
    { key: "NEDBANK (Swaziland)", code: "360064", branch: "Universal" },
    { key: "OTHER", code: "", branch: "Universal" },
    { key: "PEP BANK (NEDBANK)", code: "400001", branch: "Universal" },
    { key: "PERMANENT BANK", code: "760005", branch: "Universal" },
    { key: "RESERVE BANK", code: "", branch: "Universal" },
    { key: "SA BANK OF ATHENS", code: "410506", branch: "Universal" },
    { key: "SA POST OFFICE", code: "460005", branch: "Universal" },
    { key: "STANDARD BANK", code: "051001", branch: "Universal" },
    { key: "STANDARD BANK (SWAZILAND)", code: "660564", branch: "Universal" },
    { key: "STANDARD CHARTERED BANK (20TWENTY)", code: "730020", branch: "Universal" },
    { key: "STANDARD LESOTHO BANK LIMITED", code: "060667", branch: "Universal" },
    { key: "UBAN BANK", code: "431010", branch: "Universal" },
    { key: "Wesbank", code: "", branch: "Universal" }
]

export const TERMS_CONDITIONS_TEMPLATE = `
<div class="px-3 modal-info text-xs text-darkblue fw-light scrollable-content">
  <p class="fw-bold">Introduction to Verify's Ts & Cs:</p>
  <p>
    Welcome to the Terms and Conditions overview for Verify. These terms govern the relationship between users and Verify, 
    ensuring compliance with legal regulations and outlining the responsibilities of all parties involved. As part of the 
    onboarding process, we will verify the information that you provide, ensuring the accuracy and security of our platform. 
    By using our platform, you agree to abide by these terms, which are designed to protect your rights, ensure fair usage, 
    and maintain the integrity of our services.
  </p>
  <p class="fw-bold">Compliance with Laws:</p>
  <p>
    The Client agrees to comply with all relevant laws and regulations regarding the processing of information and the use of 
    Verify services. This includes cooperation with any investigations required by law.
  </p>
  <p class="fw-bold">User Details and Security:</p>
  <p>
    The Client will provide user details as requested by Verify for the purpose of creating login credentials and onboarding. 
    Verify reserves the right to take necessary actions to preserve network security and reliability. The Client must promptly 
    report any security breaches related to Verify services.
  </p>
  <p class="fw-bold">Warranties:</p>
  <p>
    Both Parties warrant their validity and authority to enter into the Agreement. Verify does not provide warranties, 
    and is not liable for certain losses except in cases of gross negligence or wilful misconduct.
  </p>
  <p class="fw-bold">Audit Rights:</p>
  <p>
    Verify reserves the right to audit the Client's compliance with the Agreement and may request information, data, or records 
    for this purpose. The Client must cooperate with such audits and provide additional information if required.
  </p>
  <p class="fw-bold">Limitation of Liability:</p>
  <p>
    Verify shall not be liable for certain losses unless due to gross negligence or wilful misconduct. The Client is solely liable 
    for any claims arising from actions taken in reliance on information provided by Verify.
  </p>
  <p class="fw-bold">Breach:</p>
  <p>
    Either Party must remedy any breach of the Agreement within seven days of notice. The Aggrieved Party may cancel the Agreement 
    with twenty days' written notice in case of breach.
  </p>
  <p class="fw-bold">Applicable Law and Jurisdiction:</p>
  <p>
    The platform is governed by the laws of the Republic of South Africa, and the Parties consent to the jurisdiction of the 
    Magistrate's Court of South Africa for legal proceedings.
  </p>
  <p class="fw-bold">Disputes:</p>
  <p>
    Disputes shall be settled by mediation, and if necessary, by arbitration. Both Parties agree to cooperate in good faith to 
    resolve disputes.
  </p>
  <p class="fw-bold">Anti-Corruption Warranty:</p>
  <p>
    Verify is committed to compliance with anti-corruption laws, and the Client acknowledges their obligations under such laws. 
    Breach of anti-corruption laws may result in penalties and legal action.
  </p>
  <p class="fw-bold">Protection of Personal Information:</p>
  <p>
    Both Parties undertake to comply with the Protection of Personal Information Act (POPI) and agree on the handling and protection 
    of personal information exchanged under the Agreement.
  </p>
  <p class="fw-bold">Force Majeure:</p>
  <p>
    Neither Party shall be liable for failure to perform obligations due to circumstances beyond their control.
  </p>
  <p class="fw-bold">General:</p>
  <p>
    In case of conflict between the platform and the law, the law shall prevail. Any modifications to the Agreement must be in writing and 
    signed by both Parties. Indulgences granted by either Party shall not constitute waiver of rights. Successors-in-title shall be bound 
    by the Agreement.
  </p>
  <p class="fw-bold">Confidentiality:</p>
  <p>
    Both Parties agree to keep confidential all information obtained during the term of the Agreement and for a reasonable period thereafter.
  </p>
  <p class="fw-bold">Intellectual Property:</p>
  <p>
    Any intellectual property developed during the term of the Agreement shall remain the property of the respective Party, unless otherwise 
    agreed upon in writing.
  </p>
  <p class="fw-bold">Counterparts:</p>
  <p>
    The Agreement may be executed in counterparts, each of which shall be deemed an original, but all of which together shall constitute one and 
    the same instrument.
  </p>
  <p class="fw-bold">Legal Fees:</p>
  <p>
    In the event of legal action arising from the Agreement, the prevailing Party shall be entitled to recover reasonable attorney fees 
    and court costs.
  </p>
  <p class="fw-bold">Conclusion:</p>
  <p>
    In conclusion, these Terms and Conditions form the foundation of our platform's operation, providing clarity, transparency, and legal protection 
    for all users. By adhering to these terms, you contribute to a safe and trusted environment where everyone can benefit from our services. 
    We appreciate your cooperation and look forward to serving you while upholding the highest standards of integrity and professionalism.
  </p>
</div>
`;